<template>
  <div class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title">Other Application Logs</h4>
        <div>
          <button v-if="tab === 'failedLoginAttemptLogs'"  class="btn btn-pink ml-10" v-on:click="$refs.failedLoginAttemptLogsRef.refreshLogs('refresh');" :disabled="loading">
            Refresh
          </button>
        </div>
      </div>
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" @click="tab='others'" >
          <a class="nav-link active show"    href="#others-tab"
             data-toggle="tab"  role="tab" aria-controls="up">Other logs</a>
        </li>
        <li class="nav-item" @click="tab='failedLoginAttemptLogs'">
          <a class="nav-link"  data-toggle="tab"   href="#failed-tab"
             role="tab" aria-controls="down">Failed Login Attempts</a>
        </li>
      </ul>

    </div>
    <div class="card-body" style="padding-top: 0 !important;">
      <div class="tab-content customer-table mt-20">
        <div id="others-tab" class="tab-pane active show">
          <div class="customer-list-wrapper" v-if="tab==='others'">
            <OtherApplicationLogs/>
          </div>
          <div class="loader" v-else></div>
        </div>
        <div id="failed-tab" class="tab-pane fade">
          <div class="customer-list-wrapper"  v-if="tab==='failedLoginAttemptLogs'">
            <FailedLoginAttemptLogs ref="failedLoginAttemptLogsRef"/>
          </div>
          <div class="loader" v-else></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import OtherApplicationLogs from "@/components/Admin/Logs/ApplicationLogs/otherApplicationLogs.vue";
import feedbackList from "@/components/Admin/ClientFeedbacks/feedbackList.vue";
import FailedLoginAttemptLogs from "@/components/Admin/Logs/ApplicationLogs/failedLoginAttemptLogs.vue";

export default {
  name: "ApplicationLogs",
  components: {FailedLoginAttemptLogs, feedbackList, OtherApplicationLogs},
  data() {
    return {
      tab: 'others',
      loading: false,
    }
  },
  mounted() {
  }

}
</script>
<style scoped>
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5B7CFB;
}
</style>
